import React, { useEffect, useState } from 'react';

import { useFormikContext } from 'formik';

import { showAlert } from 'components/shared/Alert/Alert';
import CurrencyInput from 'components/shared/CurrencyInput/CurrencyInput';
import { withErrorBoundary } from 'components/shared/Error/Boundary';
import Input from 'components/shared/Input/Input';
import Switch from 'components/shared/Switch/Switch';
import Tabs from 'components/shared/Tabs/Tabs';

const Technology = ({
  practice,
  setShowTechnologyModal,
  surchargeOptions,
  selectedSurchargeButton,
  showCurrencyInput,
  setShowCurrencyInput,
  setSelectedSurchargeButton
}) => {
  const [tabIndex, setTabIndex] = useState(null);
  const { setFieldValue, values } = useFormikContext();

  const onButtonClick = (idx) => {
    const option = surchargeOptions[idx];
    setTabIndex(idx);
    if (isNaN(option)) {
      setShowCurrencyInput(!showCurrencyInput);
      setFieldValue('surchargeAmount', 0);
      if (selectedSurchargeButton == idx) {
        setSelectedSurchargeButton(-1);
        setSelectedSurchargeButton(0);
      } else {
        setSelectedSurchargeButton(idx);
      }
    } else if (selectedSurchargeButton == idx) {
      if (idx != 4) {
        setFieldValue('surchargeAmount', 0);
      }
      setSelectedSurchargeButton(-1);
    } else {
      setShowCurrencyInput(false);
      setSelectedSurchargeButton(idx);
      setFieldValue('surchargeAmount', option * 100);
    }
  };

  const enableSurcharge = (e) => {
    e ? setShowTechnologyModal(true) : setFieldValue('surchargeEnabled', e);
  };

  const tabsData = surchargeOptions.map((s) => ({ value: s, label: s }));

  useEffect(() => {
    const idx = tabsData.findIndex((t) => t?.value == values?.surchargeAmount / 100);
    if (idx !== -1) {
      setTabIndex(idx);
    } else {
      setTabIndex(4);
    }
  }, []);

  useEffect(() => {
    if (values?.surchargeAmount / 100 > 4) {
      showAlert({
        title: 'Percentage should not be more than 4',
        color: 'danger'
      });
      setFieldValue('surchargeAmount', 400);
    }
  }, [values?.surchargeAmount]);

  return (
    <div className="flex w-full flex-col justify-between gap-5 border-b border-l-0 border-r-0 border-t-0 border-solid border-b-neutral-100 py-5">
      <label className="font-500">Technology fee</label>
      <div className="grid w-full grid-cols-2 gap-5">
        <div className="flex items-center gap-2 py-2">
          <Switch
            onChange={(e) => {
              enableSurcharge(e);
            }}
            checked={values?.surchargeEnabled}
          />
          <label className="block font-500">Technology fee</label>
        </div>
        <Input
          type="text"
          label="Current technology fee percentage"
          disabled
          placeholder="Technology fee percentage"
          name="Technology fee percentage"
          value={
            values?.surchargeEnabled && practice?.surcharge_percentage
              ? `${practice?.surcharge_percentage}%`
              : 'No technology fee.'
          }
        />
        {practice?.surcharge && values?.surchargeEnabled && (
          <>
            <div className="flex flex-col gap-3">
              <label className="font-500">Percentage Select</label>
              <Tabs
                tabsData={tabsData}
                theme="secondary"
                hasContent
                tabIndex={tabIndex}
                setTabIndex={(i) => {
                  onButtonClick(i);
                }}
                className="!pl-0 !pr-0"
              />
            </div>
            {tabIndex == 4 && (
              <div className="flex flex-col gap-5">
                <label className="font-500">Technology fee Custom Percentage</label>
                <div>
                  <CurrencyInput
                    style="percent"
                    onValueChange={(v) => {
                      setFieldValue('surchargeAmount', v);
                    }}
                    placeholder={`${values?.surchargeAmount}%`}
                    min={0}
                    value={values?.surchargeAmount}
                  />
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default withErrorBoundary(Technology);
